export default "/images/4df35e29369364eb7b9fa89a1efb3f18.avif";